function getCheckoutData(checkoutDataStr: string | null) {
  try {
    const checkoutData = checkoutDataStr
      ? JSON.parse(atob(checkoutDataStr))
      : {};
    const queryUserId = checkoutData.userid;
    const queryExpiryDate = checkoutData?.expiring_at?.epoch;
    const queryDiscountPercent = checkoutData?.discount_percent;
    const isExpired =
      queryExpiryDate && parseInt(queryExpiryDate, 10) <= Date.now();
    return {
      checkoutData,
      checkoutDataUserId: queryUserId,
      discount: queryDiscountPercent / 100,
      isExpired
    };
  } catch (e) {
    return {
      checkoutData: {},
      checkoutDataUserId: undefined,
      discount: 1,
      isExpired: true
    };
  }
}

export default getCheckoutData;
